module.exports = __webpack_public_path__ + "static/media/insect(36).142f53b8.PNG";